import React, { useEffect, useState } from "react";
import members from "../../assets/images/avatar/members.png";
import http, { baseURL } from "../../utils/axios";
import {
  BulbIcon,
  HeaderIcon,
  LogoutIconNav,
  MoonIcon,
  MyProfileIcon,
} from "../../assets/svgs";
import axios from "axios";

export default function ResponsiveHeader({ toggleActive }) {
  const [isActive, setIsActive] = React.useState(false);

  const profileAction = () => {
    setIsActive(!isActive);
  };

  const [avatar, setAvatar] = useState(
    "https://www.w3schools.com/howto/img_avatar.png"
  );


  return (
    <header class="md:block hidden header-wrapper w-full fixed z-30">
      <div class="w-full h-[108px] dark:bg-darkblack-600 bg-white flex items-center justify-between 2xl:px-[76px] px-10 relative">
        <button
          title="Ctrl+b"
          type="button"
          class="drawer-btn absolute left-0 top-auto transform rotate-180"
          onClick={toggleActive}
        >
          <span>
            <HeaderIcon />
          </span>
        </button>

        <div>
          <h3 class="lg:text-3xl text-xl dark:text-bgray-50 text-bgray-900 font-bold lg:leading-[36.4px]">
            Admin Side
          </h3>
          <p class="lg:text-sm text-xs dark:text-bgray-50 text-bgray-600 font-medium lg:leading-[25.2px]">
              Let’s check your update today
          </p>
        </div>

        {/* <SearchBar /> */}

        <div class="quick-access-wrapper relative">
          <div class="flex space-x-[43px] items-center">
            <div class="xl:flex hidden space-x-5 items-center">
              <ThemeToggle />
              {/* <NotificationButton />
              <MessageButton />
              <StoreButton /> */}
            </div>

            <div
              onClick={profileAction}
              class="flex lg:space-x-3 space-x-0 cursor-pointer"
            >
              <div class="w-[52px] h-[52px] rounded-xl overflow-hidden">
                <img
                  class="object-cover "
                  src={
                     "https://www.w3schools.com/howto/img_avatar.png"
                  }
                  style={{ objectFit: "cover", minHeight: "100%" }}
                  alt="avater"
                />
              </div>
       
            </div>
          </div>
{/* 
          <NotificationPopup />
          <MessagePopup />
          <StorePopup /> */}
          <ProfileMenu isActive={isActive} />
        </div>
      </div>
    </header>
  );
}

const SearchBar = () => {
  return (
    <div className="searchbar-wrapper">
      <div className="border border-transparent focus-within:border-red-300 lg:w-[400px] w-[300px] px h-[56px] px-4 bg-bgray-50 dark:bg-darkblack-500 rounded-lg flex justify-between items-center">
        <div className="flex space-x-3.5 items-center w-full">
          <span>
            <svg
              className="stroke-bgray-900 dark:stroke-bgray-50"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="9.78639"
                cy="9.78602"
                r="8.23951"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.5176 15.9447L18.7479 19.1667"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <label htmlhtmlFor="search" className="w-full">
            <input
              type="text"
              id="search"
              placeholder="Search..."
              className="search-input w-full bg-none border-none bg-bgray-50 px-0 focus:outline-none focus:ring-0 text-sm placeholder:text-sm text-bgray-600 tracking-wide placeholder:font-semibold dark:placeholder:text-bgray-500 dark:bg-darkblack-500"
            />
          </label>
        </div>
        <div className="flex space-x-[6px] items-center">
          <span>
            <svg
              className="stroke-bgray-900 dark:stroke-gray-300"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.975 12.3875C5.975 12.8548 5.83644 13.3115 5.57685 13.7C5.31725 14.0885 4.94828 14.3914 4.51659 14.5702C4.0849 14.749 3.60988 14.7958 3.1516 14.7046C2.69332 14.6134 2.27236 14.3884 1.94196 14.058C1.61156 13.7276 1.38655 13.3067 1.2954 12.8484C1.20424 12.3901 1.25102 11.9151 1.42984 11.4834C1.60865 11.0517 1.91146 10.6827 2.29997 10.4232C2.68848 10.1636 3.14524 10.025 3.6125 10.025H12.3875C12.8548 10.025 13.3115 10.1636 13.7 10.4232C14.0885 10.6827 14.3914 11.0517 14.5702 11.4834C14.749 11.9151 14.7958 12.3901 14.7046 12.8484C14.6134 13.3067 14.3884 13.7276 14.058 14.058C13.7276 14.3884 13.3067 14.6134 12.8484 14.7046C12.3901 14.7958 11.9151 14.749 11.4834 14.5702C11.0517 14.3914 10.6827 14.0885 10.4232 13.7C10.1636 13.3115 10.025 12.8548 10.025 12.3875V3.6125C10.025 3.14524 10.1636 2.68848 10.4232 2.29997C10.6827 1.91146 11.0517 1.60865 11.4834 1.42984C11.9151 1.25102 12.3901 1.20424 12.8484 1.2954C13.3067 1.38655 13.7276 1.61156 14.058 1.94196C14.3884 2.27236 14.6134 2.69332 14.7046 3.1516C14.7958 3.60988 14.749 4.0849 14.5702 4.51659C14.3914 4.94828 14.0885 5.31725 13.7 5.57685C13.3115 5.83644 12.8548 5.975 12.3875 5.975H3.6125C3.14524 5.975 2.68848 5.83644 2.29997 5.57685C1.91146 5.31725 1.60865 4.94828 1.42984 4.51659C1.25102 4.0849 1.20424 3.60988 1.2954 3.1516C1.38655 2.69332 1.61156 2.27236 1.94196 1.94196C2.27236 1.61156 2.69332 1.38655 3.1516 1.2954C3.60988 1.20424 4.0849 1.25102 4.51659 1.42984C4.94828 1.60865 5.31725 1.91146 5.57685 2.29997C5.83644 2.68848 5.975 3.14524 5.975 3.6125V12.3875Z"
                strokeWidth="1.5"
              />
            </svg>
          </span>
          <span className="text-base dark:text-bgray-300 text-bgray-900">
            K
          </span>
        </div>
      </div>
    </div>
  );
};

const NotificationPopup = () => {
  const notificationAction = () => {
    // Handle notification action
  };

  return (
    <div className="notification-popup-wrapper">
      <div
        onClick={notificationAction}
        id="noti-outside"
        className="w-full h-full fixed -left-[43px] top-0 hidden"
      ></div>
      <div
        id="notification-box"
        style={{
          filter: "drop-shadow(12px 12px 40px rgba(0, 0, 0, 0.08))",
        }}
        className="w-[400px] bg-white dark:bg-darkblack-600 absolute -left-[347px] top-[81px] rounded-lg hidden"
      >
        <div className="w-full pt-[66px] pb-[75px] relative">
          <div className="w-full h-[66px] flex justify-between items-center absolute left-0 top-0 px-8">
            <h3 className="text-xl text-bgray-900 dark:text-white font-bold">
              Notifications
            </h3>
            <span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.325 4.317C10.751 2.561 13.249 2.561 13.675 4.317C13.7389 4.5808 13.8642 4.82578 14.0407 5.032C14.2172 5.23822 14.4399 5.39985 14.6907 5.50375C14.9414 5.60764 15.2132 5.65085 15.4838 5.62987C15.7544 5.60889 16.0162 5.5243 16.248 5.383C17.791 4.443 19.558 6.209 18.618 7.753C18.4769 7.98466 18.3924 8.24634 18.3715 8.51677C18.3506 8.78721 18.3938 9.05877 18.4975 9.30938C18.6013 9.55999 18.7627 9.78258 18.9687 9.95905C19.1747 10.1355 19.4194 10.2609 19.683 10.325C21.439 10.751 21.439 13.249 19.683 13.675C19.4192 13.7389 19.1742 13.8642 18.968 14.0407C18.7618 14.2172 18.6001 14.4399 18.4963 14.6907C18.3924 14.9414 18.3491 15.2132 18.3701 15.4838C18.3911 15.7544 18.4757 16.0162 18.617 16.248C19.557 17.791 17.791 19.558 16.247 18.618C16.0153 18.4769 15.7537 18.3924 15.4832 18.3715C15.2128 18.3506 14.9412 18.3938 14.6906 18.4975C14.4401 18.6013 14.2175 18.7627 14.041 18.9687C13.8645 19.1747 13.7391 19.4194 13.675 19.683C13.249 21.439 10.751 21.439 10.325 19.683C10.2611 19.4189 10.1358 19.1739 9.9593 18.9687C9.78283 18.7635 9.56025 18.6021 9.30962 18.4983C9.05899 18.3945 8.78743 18.3512 8.516 18.3702C8.24557 18.3892 7.98416 18.4738 7.753 18.615C6.21 19.555 4.443 17.789 5.383 16.245C5.5243 16.0148 5.60889 15.7534 5.62987 15.4829C5.65085 15.2125 5.60764 14.941 5.50375 14.6904C5.39985 14.4398 5.23822 14.2172 5.032 14.0407C4.82578 13.8642 4.5808 13.7389 4.317 13.675C2.561 13.249 2.561 10.751 4.317 10.325C4.5808 10.2611 4.82578 10.1358 5.032 9.9593C5.23822 9.78283 5.39985 9.56025 5.50375 9.30962C5.60764 9.05899 5.65085 8.78743 5.62987 8.516C5.60889 8.24557 5.5243 7.98416 5.383 7.753C4.443 6.21 6.209 4.443 7.753 5.383C7.98416 5.5243 8.24557 5.60889 8.516 5.62987C8.78643 5.65085 9.05799 5.60764 9.30862 5.50375C9.55926 5.39985 9.78185 5.23822 9.95832 5.032C10.1348 4.82578 10.2602 4.5808 10.325 4.317Z"
                  fill="#4B5563"
                />
              </svg>
            </span>
          </div>
          <div className="px-8">
            <div className="mb-8">
              <h4 className="text-xl text-bgray-900 dark:text-white mb-4 font-bold">
                You have a new notification
              </h4>
              <p className="text-bgray-700 dark:text-bgray-400">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                auctor, nisi vel ultrices hendrerit, quam felis faucibus tortor,
                eu iaculis nunc lectus et risus.
              </p>
            </div>
            <div className="flex justify-end">
              <button
                onClick={notificationAction}
                className="text-white bg-blue-500 hover:bg-blue-600 py-2 px-6 rounded-lg"
              >
                View
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const MessagePopup = () => {
  const messageAction = () => {
    const messageBox = document.getElementById("message-box");
    const messageOutside = document.getElementById("mes-outside");

    messageBox.classList.toggle("hidden");
    messageOutside.classList.toggle("hidden");
  };
  return (
    <div className="message-popup-wrapper">
      <div
        onClick={messageAction}
        id="mes-outside"
        className="w-full h-full fixed -left-[43px] top-0 hidden"
      ></div>
      <div
        id="message-box"
        style={{ filter: "drop-shadow(12px 12px 40px rgba(0, 0, 0, 0.08))" }}
        className="w-[400px] bg-white dark:bg-darkblack-600 absolute -left-[276px] top-[81px] rounded-lg hidden"
      >
        <div className="w-full pt-[66px] pb-[75px] relative">
          <div className="w-full h-[66px] flex justify-between items-center absolute left-0 top-0 px-8">
            <h3 className="text-xl text-bgray-900 dark:text-white font-bold">
              Message
            </h3>
            <span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.325 4.317C10.751 2.561 13.249 2.561 13.675 4.317C13.7389 4.5808 13.8642 4.82578 14.0407 5.032C14.2172 5.23822 14.4399 5.39985 14.6907 5.50375C14.9414 5.60764 15.2132 5.65085 15.4838 5.62987C15.7544 5.60889 16.0162 5.5243 16.248 5.383C17.791 4.443 19.558 6.209 18.618 7.753C18.4769 7.98466 18.3924 8.24634 18.3715 8.51677C18.3506 8.78721 18.3938 9.05877 18.4975 9.30938C18.6013 9.55999 18.7627 9.78258 18.9687 9.95905C19.1747 10.1355 19.4194 10.2609 19.683 10.325C21.439 10.751 21.439 13.249 19.683 13.675C19.4192 13.7389 19.1742 13.8642 18.968 14.0407C18.7618 14.2172 18.6001 14.4399 18.4963 14.6907C18.3924 14.9414 18.3491 15.2132 18.3701 15.4838C18.3911 15.7544 18.4757 16.0162 18.617 16.248C19.557 17.791 17.791 19.558 16.247 18.618C16.0153 18.4769 15.7537 18.3924 15.4833 18.3715C15.2129 18.3506 14.9413 18.3938 14.6907 18.4975C14.4401 18.6013 14.2175 18.7627 14.041 18.9687C13.8645 19.1747 13.7391 19.4194 13.675 19.683C13.249 21.439 10.751 21.439 10.325 19.683C10.2611 19.4192 10.1358 19.1742 9.9593 18.968C9.78282 18.7618 9.56025 18.6001 9.30963 18.4963C9.05902 18.3924 8.78746 18.3491 8.51602 18.3701C8.24458 18.3911 7.98294 18.4757 7.75126 18.617C6.20726 19.557 4.44026 17.791 5.38026 16.247C5.52251 16.0153 5.60691 15.7537 5.62793 15.4833C5.64894 15.2129 5.60573 14.9413 5.50192 14.6907C5.39812 14.4401 5.23651 14.2175 5.06005 14.041C4.88359 13.8645 4.63887 13.7391 4.37526 13.675C2.61926 13.249 2.61926 10.751 4.37526 10.325C4.63887 10.2611 4.88359 10.1358 5.06005 9.9593C5.23651 9.78282 5.39812 9.56025 5.50192 9.30963C5.60573 9.05902 5.64894 8.78746 5.62793 8.51602C5.60691 8.24458 5.52251 7.98294 5.38026 7.75126C4.44026 6.20726 6.20726 4.44026 7.75126 5.38026C7.98294 5.52251 8.24458 5.60691 8.51602 5.62793C8.78746 5.64894 9.05902 5.60573 9.30963 5.50192C9.56025 5.39812 9.78282 5.23651 9.9593 5.06005C10.1358 4.88359 10.2611 4.63887 10.325 4.37526"
                  fill="#111827"
                />
                <path
                  d="M7.12499 9.375L9.375 7.125L15.75 13.5L16.875 12.375L10.5 6L12.75 3.75H3.75V12.75L6 10.5L11.625 16.125L12.75 17.25L17.25 12.75V3.75H6L7.125 4.875L3.375 8.625L4.5 9.75L7.125 7.125L9.375 9.375H7.12499Z"
                  fill="#111827"
                />
              </svg>
            </span>
          </div>
          <div className="w-full px-8">
            <h3 className="text-lg text-bgray-900 dark:text-white font-bold mb-4">
              Lorem Ipsum
            </h3>
            <p className="text-sm text-bgray-500 dark:text-bgray-400 leading-6 mb-4">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean
              euismod bibendum laoreet. Proin gravida dolor sit amet lacus
              accumsan et viverra justo commodo. Proin sodales pulvinar tempor.
              Cum sociis natoque penatibus et magnis dis parturient montes,
              nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra
              vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget
              odio.
            </p>
            <p className="text-sm text-bgray-500 dark:text-bgray-400 leading-6">
              Donec eleifend cursus lobortis. Mauris aliquet urna sit amet
              ligula porta, nec rhoncus eros consectetur. Vestibulum ante ipsum
              primis in faucibus orci luctus et ultrices posuere cubilia
              Curae...
            </p>
          </div>
        </div>
        <div className="w-full bg-blue-100 dark:bg-bgray-800 py-2 px-4 absolute bottom-0 left-0 rounded-b-lg">
          <button
            onClick={messageAction}
            className="bg-blue-500 hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-700 text-white font-bold py-2 px-8 rounded-full focus:outline-none"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

const StorePopup = () => {
  const storeAction = () => {
    const storeBox = document.getElementById("store-box");
    const storeOutside = document.getElementById("store-outside");

    storeBox.classList.toggle("hidden");
    storeOutside.classList.toggle("hidden");
  };

  return (
    <div className="store-wrapper">
      <div
        id="store-outside"
        onClick={storeAction}
        className="w-full h-full fixed -left-[43px] top-0 hidden"
      ></div>
      <div
        id="store-box"
        style={{ filter: "drop-shadow(12px 12px 40px rgba(0, 0, 0, 0.08))" }}
        className="w-[330px] overflow-hidden bg-white dark:bg-darkblack-600 absolute -left-[134px] top-[81px] rounded-lg hidden"
      >
        <div className="w-full p-6 relative">
          <div className="bonus-box-wrapper overflow-hidden w-full pb-[33px]">
            <div className="bonus-box w-full flex justify-center relative">
              <div
                style={{ width: "calc(100% - 20px)" }}
                className="absolute left-[10px] top-[5px] h-[200px] bg-success-200 rounded-lg"
              ></div>
              <div className="w-full p-5 bg-success-300 rounded-lg relative">
                <h3 className="text-[28px] text-white font-bold text-center">
                  60% Bonus
                </h3>
                <p className="text-lg font-semibold text-success-100 leading-[24px] text-center px-5 mb-3">
                  Create an Account and Get Bonus
                </p>
                <div className="flex justify-center">
                  <a href="#">
                    <div className="w-[166px] h-[56px] flex justify-center items-center rounded-lg bg-warning-300 hover:bg-warning-200 transition duration-300 ease-in-out">
                      <span className="text-bgray-900 text-sm font-bold">
                        Discover More
                      </span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="progess-bar flex justify-center mb-[13px]">
            <div className="bonus-per relative">
              <div className="bonus-outer">
                <div className="bonus-inner">
                  <div className="number">
                    <span className="text-sm font-medium text-bgray-900">
                      25%
                    </span>
                  </div>
                </div>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="80px"
                height="80px"
              >
                <circle
                  style={{ strokeDashoffset: "calc(215 - 215 * (25 / 100))" }}
                  cx="40"
                  cy="40"
                  r="35"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          </div>
          <p className="text-sm font-semibold text-success-300 text-center mb-2.5">
            Discover more
          </p>
          <div className="flex justify-center">
            <img src={members} alt="members" />
          </div>
        </div>
      </div>
    </div>
  );
};

const ProfileMenu = ({ isActive }) => {
  return (
    <div className="profile-wrapper">
      <div
        style={{
          filter: "drop-shadow(12px 12px 40px rgba(0, 0, 0, 0.08))",
        }}
        className={`profile-box w-[300px] overflow-hidden bg-white dark:bg-darkblack-600 absolute right-0 top-[81px] rounded-lg ${
          isActive ? "" : "hidden"
        }`}
      >
        <div className="w-full px-3 py-2 relative">
          <div>
            <ul>
              {/* <li className="w-full">
                <a href="/publisher/profile">
                  <div className="flex space-x-[18px] items-center p-[14px] hover:bg-bgray-100 hover:dark:bg-darkblack-500 rounded-lg text-bgray-600 hover:text-bgray-900">
                    <div className="w-[20px]">
                      <span>
                        <MyProfileIcon />
                      </span>
                    </div>
                    <div className="flex-1">
                      <span className="text-sm font-semibold text-bgray-900 dark:text-white">
                        My Profile
                      </span>
                    </div>
                  </div>
                </a>
              </li> */}

              <li
                className="w-full"
                onClick={() => {
                  localStorage.clear();
                  window.location.href = "/signin";
                }}
              >
                <a href="#">
                  <div className="flex space-x-[18px] items-center p-[14px] rounded-lg text-success-300">
                    <div className="w-[20px]">
                      <span>
                        <LogoutIconNav />
                      </span>
                    </div>
                    <div className="flex-1">
                      <span className="text-sm font-semibold">Log Out</span>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </div>
          {/* <div className="w-full h-[1px] my-[14px] bg-bgray-300"></div>
          <div>
            <ul>
              <li className="w-full">
                <a href="settings.html">
                  <div className="p-[14px] hover:bg-bgray-100 dark:hover:bg-darkblack-500 rounded-lg text-bgray-600 dark:text-bgray-50 hover:text-bgray-900">
                    <span className="text-sm font-semibold">Settings</span>
                  </div>
                </a>
              </li>
              <li className="w-full">
                <a href="users.html">
                  <div className="p-[14px] hover:bg-bgray-100 dark:hover:bg-darkblack-500 rounded-lg text-bgray-600 dark:text-bgray-50 hover:text-bgray-900">
                    <span className="text-sm font-semibold">Users</span>
                  </div>
                </a>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </div>
  );
};

const ThemeToggle = () => {
  const handleToggle = () => {
    toggleTheme();
  };

  const [theme, setTheme] = React.useState(
    localStorage.getItem("theme") || "light"
  );

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
  };

  React.useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, [theme]);

  const isDarkMode = Boolean(theme === "dark");
  return (
    <button
      type="button"
      id="theme-toggle"
      className={`w-[52px] h-[52px] rounded-[12px] border border-red-300 flex justify-center items-center relative`}
      onClick={handleToggle}
    >
      {isDarkMode ? <BulbIcon /> : <MoonIcon />}
    </button>
  );
};

const NotificationButton = () => {
  const notificationAction = () => {};
  return (
    <button
      onClick={notificationAction}
      id="notification-btn"
      type="button"
      className="w-[52px] h-[52px] rounded-[12px] border border-red-300 dark:border-darkblack-400 flex justify-center items-center relative"
    >
      <span className="w-3.5 h-3.5 rounded-full bg-bgray-300 dark:bg-bgray-600 dark:border-none border-2 border-white absolute -right-[5px] -top-[2px]"></span>
      <svg
        className="fill-bgray-900 dark:fill-white"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19.9718 6.78149L19.2803 7.07178L19.9718 6.78149ZM19.3571 7.25473C19.5174 7.63666 19.957 7.81631 20.3389 7.65599C20.7209 7.49567 20.9005 7.05609 20.7402 6.67416L19.3571 7.25473ZM16.7784 2.77061C16.3937 2.61687 15.9573 2.80404 15.8036 3.18867C15.6498 3.5733 15.837 4.00973 16.2216 4.16347L16.7784 2.77061ZM16.6672 3.53388L16.3889 4.23031L16.6672 3.53388ZM4.0768 6.78149L4.76834 7.07178L4.0768 6.78149ZM3.30846 6.67416C3.14813 7.05609 3.32778 7.49567 3.70971 7.65599C4.09164 7.81631 4.53122 7.63666 4.69154 7.25473L3.30846 6.67416ZM7.82701 4.16347C8.21164 4.00973 8.39881 3.5733 8.24507 3.18867C8.09134 2.80405 7.65491 2.61687 7.27028 2.77061L7.82701 4.16347ZM7.38142 3.53388L7.10305 2.83745V2.83745L7.38142 3.53388ZM18.2395 9.93743L17.4943 10.0221V10.0221L18.2395 9.93743ZM18.6867 13.8746L19.4319 13.7899V13.7899L18.6867 13.8746ZM5.31328 13.8746L4.56807 13.7899L5.31328 13.8746ZM5.76046 9.93743L6.50567 10.0221L5.76046 9.93743ZM4.44779 15.83L3.87686 15.3436H3.87686L4.44779 15.83ZM19.5522 15.83L18.9813 16.3164L18.9813 16.3164L19.5522 15.83ZM14.2699 5.33931H13.5199C13.5199 5.65996 13.7238 5.94513 14.0272 6.04893L14.2699 5.33931ZM9.73005 5.33931L9.97284 6.04893C10.2762 5.94513 10.4801 5.65996 10.4801 5.33931H9.73005ZM15.7022 21.2175C15.8477 20.8296 15.6512 20.3973 15.2634 20.2518C14.8755 20.1064 14.4432 20.3029 14.2978 20.6907L15.7022 21.2175ZM9.70223 20.6907C9.55678 20.3029 9.12446 20.1064 8.73663 20.2518C8.34879 20.3973 8.15231 20.8296 8.29777 21.2175L9.70223 20.6907ZM19.2803 7.07178L19.3571 7.25473L20.7402 6.67416L20.6634 6.4912L19.2803 7.07178ZM16.2216 4.16347L16.3889 4.23031L16.9456 2.83745L16.7784 2.77061L16.2216 4.16347ZM20.6634 6.4912C19.9638 4.82468 18.6244 3.50849 16.9456 2.83745L16.3889 4.23031C17.6948 4.7523 18.7364 5.77599 19.2803 7.07178L20.6634 6.4912ZM3.38526 6.4912L3.30846 6.67416L4.69154 7.25473L4.76834 7.07178L3.38526 6.4912ZM7.27028 2.77061L7.10305 2.83745L7.65979 4.23031L7.82701 4.16347L7.27028 2.77061ZM4.76834 7.07178C5.31227 5.77599 6.35384 4.7523 7.65979 4.23031L7.10305 2.83745C5.4242 3.50849 4.08481 4.82468 3.38526 6.4912L4.76834 7.07178ZM17.7772 18.2056H6.22281V19.7056H17.7772V18.2056ZM17.4943 10.0221L17.9415 13.9592L19.4319 13.7899L18.9847 9.85279L17.4943 10.0221ZM6.05849 13.9592L6.50567 10.0221L5.01526 9.85279L4.56807 13.7899L6.05849 13.9592ZM5.01872 16.3164C5.59608 15.6386 5.96025 14.8241 6.05849 13.9592L4.56807 13.7899C4.50522 14.3432 4.2708 14.8812 3.87686 15.3436L5.01872 16.3164ZM17.9415 13.9592C18.0398 14.8241 18.4039 15.6386 18.9813 16.3164L20.1231 15.3436C19.7292 14.8812 19.4948 14.3432 19.4319 13.7899L17.9415 13.9592ZM6.22281 18.2056C5.5675 18.2056 5.10418 17.8817 4.89044 17.5053C4.68417 17.1421 4.68715 16.7056 5.01872 16.3164L3.87686 15.3436C3.11139 16.2422 3.0877 17.3685 3.5861 18.2461C4.07704 19.1105 5.04975 19.7056 6.22281 19.7056V18.2056ZM17.7772 19.7056C18.9503 19.7056 19.923 19.1105 20.4139 18.2461C20.9123 17.3685 20.8886 16.2422 20.1231 15.3436L18.9813 16.3164C19.3129 16.7056 19.3158 17.1421 19.1096 17.5053C18.8958 17.8817 18.4325 18.2056 17.7772 18.2056V19.7056ZM15.0199 5.33931V5.23567H13.5199V5.33931H15.0199ZM18.9847 9.85279C18.7054 7.39374 16.8802 5.43969 14.5127 4.6297L14.0272 6.04893C15.9445 6.70491 17.2914 8.23516 17.4943 10.0221L18.9847 9.85279ZM10.4801 5.33931V5.23567H8.98005V5.33931H10.4801ZM6.50567 10.0221C6.70863 8.23516 8.05551 6.70491 9.97284 6.04893L9.48727 4.6297C7.1198 5.43969 5.29456 7.39374 5.01526 9.85279L6.50567 10.0221ZM12 3.71741C12.84 3.71741 13.5199 4.39768 13.5199 5.23567H15.0199C15.0199 3.56821 13.6673 2.21741 12 2.21741V3.71741ZM12 2.21741C10.3327 2.21741 8.98005 3.56821 8.98005 5.23567H10.4801C10.4801 4.39768 11.16 3.71741 12 3.71741V2.21741ZM14.2978 20.6907C13.9752 21.5508 13.0849 22.2026 12 22.2026V23.7026C13.6851 23.7026 15.1514 22.686 15.7022 21.2175L14.2978 20.6907ZM12 22.2026C10.9151 22.2026 10.0248 21.5508 9.70223 20.6907L8.29777 21.2175C8.84856 22.686 10.3149 23.7026 12 23.7026V22.2026Z" />
      </svg>
    </button>
  );
};

const MessageButton = () => {
  const messageAction = () => {
    // Add your message action logic here
  };

  return (
    <button
      onClick={messageAction}
      id="message-btn"
      type="button"
      className="w-[52px] h-[52px] rounded-[12px] border border-red-300 dark:border-darkblack-400 flex justify-center items-center relative"
    >
      <span className="w-3.5 h-3.5 rounded-full bg-error-300 border-2 border-white absolute -right-[5px] -top-[2px] dark:border-none"></span>
      <svg
        className="stroke-bgray-900 dark:stroke-white"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 12V7C2 4.79086 3.79086 3 6 3H18C20.2091 3 22 4.79086 22 7V17C22 19.2091 20.2091 21 18 21H8M6 8L9.7812 10.5208C11.1248 11.4165 12.8752 11.4165 14.2188 10.5208L18 8M2 15H8M2 18H8"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
};

const StoreButton = () => {
  const storeAction = () => {
    // Add your store action logic here
  };

  return (
    <button
      onClick={storeAction}
      id="store-btn"
      type="button"
      className="w-[52px] h-[52px] rounded-[12px] border border-red-300 dark:border-darkblack-400 flex justify-center items-center relative"
    >
      <span className="w-3.5 h-3.5 rounded-full bg-bgray-300 border-2 border-white absolute -right-[5px] -top-[2px] dark:bg-bgray-600 dark:border-none "></span>
      <svg
        className="stroke-bgray-900 dark:stroke-white"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 11H20M4 11C2.89543 11 2 10.1046 2 9V8C2 6.89543 2.89543 6 4 6H20C21.1046 6 22 6.89543 22 8V9C22 10.1046 21.1046 11 20 11M4 11L4 20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V11M12 6H16C17.1046 6 18 5.10457 18 4C18 2.89543 17.1046 2 16 2C13.7909 2 12 3.79086 12 6ZM12 6H8C6.89543 6 6 5.10457 6 4C6 2.89543 6.89543 2 8 2C10.2091 2 12 3.79086 12 6ZM12 6V22"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
};
